<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-row>
      <v-col>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          color="primary"
        />
      </v-col>
    </v-row>
    <sequential-entrance from-top>
      <v-row>
        <v-col
          sm="12"
          md="12"
          lg="12"
        >
          <base-material-card
            v-if="!loading"
            color="primary"
            icon="mdi-map-marker-radius"
            inline
            title="Location Reports"
          >
            <v-col cols="12">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              />
            </v-col>
            <v-spacer />
            <v-data-table
              :headers="headerforlevel"
              :items="getlocs"
              :items-per-page="itemsPerPage"
              :search="search"
              :page.sync="page"
              @page-count="pageCount = $event"
            >
              <template v-slot:[`item.live`]="{ item }">
                <v-btn
                  v-if="userallowed"
                  fab
                  small
                  color="blue darken-4"
                  :to="'/ReportLive/' + item.idnum"
                  dark
                >
                  <v-icon dark>
                    mdi-youtube-tv
                  </v-icon>
                </v-btn>
              </template>
              <template v-slot:[`item.deposits`]="{ item }">
                <v-btn
                  fab
                  color="green"
                  small
                  :to="'/ReportDeposit/' + item.idnum"
                  dark
                >
                  <v-icon dark>
                    mdi-account-cash-outline
                  </v-icon>
                </v-btn>
              </template>
              <template v-slot:[`item.cit`]="{ item }">
                <v-btn
                  fab
                  small
                  color="purple"
                  :to="'/ReportTransit/' + item.idnum"
                  dark
                >
                  <v-icon dark>
                    mdi-transfer-right
                  </v-icon>
                </v-btn>
              </template>
              <template v-slot:[`item.cashin`]="{ item }">
                <v-btn
                  fab
                  small
                  color="orange"
                  :to="'/reportcashin/' + item.idnum"
                  dark
                >
                  <v-icon dark>
                    mdi-calendar-today
                  </v-icon>
                </v-btn>
              </template>
              <template v-slot:[`item.monthly`]="{ item }">
                <v-btn
                  fab
                  small
                  color="red"
                  :to="'/reportmonth/' + item.idnum"
                  dark
                >
                  <v-icon dark>
                    mdi-chart-areaspline
                  </v-icon>
                </v-btn>
              </template>
            </v-data-table>
            <div class="text-center pt-2">
              <v-pagination
                v-model="page"
                :length="pageCount"
              />
            </div>
          </base-material-card>
        </v-col>
      </v-row>
    </sequential-entrance>
  </v-container>
</template>

<script>
  import moment from 'moment'

  export default {

    name: 'Locations',

    data () {
      return {
        search: '',
        loading: false,
        page: 1,
        pageCount: 0,
        itemsPerPage: 10,
        chartOptions: {
          chart: {
            id: 'vuechart-example'
          },
          xaxis: {
            categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998]
          }
        },
        series: [{
          name: 'series-1',
          data: [30, 40, 35, 50, 49, 60, 70, 91]
        }],
        sites: this.$store.getters.loadedSites,
        profiles: this.$store.getters.loadedSiteProfiles,
        locations: [],
        locationHeaders: [
          {
            sortable: true,
            text: 'Sites ID',
            value: 'idnum',
          },
          {
            sortable: true,
            text: 'Group',
            value: 'group'
          },
          {
            sortable: true,
            text: 'Status',
            value: 'status'
          },
          {
            sortable: false,
            text: 'Live View',
            value: 'live',
            align: 'center'
          },
          {
            sortable: false,
            text: 'Deposit Events',
            value: 'deposits',
            align: 'center'
          },
          {
            sortable: false,
            text: 'Cash in Transit',
            value: 'cit',
            align: 'center'
          },
          {
            align: 'center',
            sortable: false,
            value: 'cashin',
            text: 'Daily Volume'
          },
        ],
        icons: true,
        centered: true,
        newtab: null,
        activeBtn: 1,
        grow: true,
        tab: null,
        tabs: 0,

        list: {
          0: false,
          1: false,
          2: false
        }
      }
    },
    computed: {
      totalSales () {
        return this.sales.reduce((acc, val) => acc + val.salesInM, 0)
      },
      userallowed () {
        if (this.$store.getters.user.status === 'storemanager') {
          return false
        }
        return true
      },
      headerforlevel () {
        this.$log.debug('user level is ', this.$store.getters.user.status)
        if (this.$store.getters.user.status === 'vieweronly') {
          // nothing they can do
        } else if (this.$store.getters.user.status === 'storemanager') {
          return [{
                    sortable: true,
                    text: 'Sites ID',
                    value: 'idnum',
                    width: 200
                  },
                  {
                    sortable: true,
                    text: 'Group',
                    value: 'group',
                    width: 200
                  },
                  {
                    sortable: true,
                    text: 'Status',
                    value: 'status'
                  },
                  {
                    sortable: false,
                    text: 'Deposit Events',
                    value: 'deposits',
                    align: 'center'
                  },
                  {
                    sortable: false,
                    text: 'Cash in Transit',
                    value: 'cit',
                    align: 'center'
                  },
                  {
                    align: 'center',
                    sortable: false,
                    value: 'cashin',
                    text: 'Daily Volume'
                  },
                  {
                    align: 'center',
                    sortable: false,
                    value: 'monthly',
                    text: 'Monthly Volume'
                  }
          ]
        } else if (this.$store.getters.user.status === 'groupmanager') {
          return [
            {
              sortable: true,
              text: 'Sites ID',
              value: 'idnum',
              width: 200
            },
            {
              sortable: true,
              text: 'Group',
              value: 'group',
              width: 200
            },
            {
              sortable: true,
              text: 'Status',
              value: 'status'
            },
            {
              sortable: false,
              text: 'Live View',
              value: 'live',
              align: 'center'
            },
            {
              sortable: false,
              text: 'Deposit Events',
              value: 'deposits',
              align: 'center'
            },
            {
              sortable: false,
              text: 'Cash in Transit',
              value: 'cit',
              align: 'center'
            },
            {
              align: 'center',
              sortable: false,
              value: 'cashin',
              text: 'Daily Volume'
            },
            {
              align: 'center',
              sortable: false,
              value: 'monthly',
              text: 'Monthly Volume'
            }
          ]
        } else if (this.$store.getters.user.status === 'corporate') {
          this.$log.debug('user is a corp user')
          return [{
                    sortable: true,
                    text: 'Sites ID',
                    value: 'idnum',
                    width: 200
                  },
                  {
                    sortable: true,
                    text: 'Group',
                    value: 'group',
                    width: 200
                  },
                  {
                    sortable: true,
                    text: 'Status',
                    value: 'status'
                  },
                  {
                    sortable: false,
                    text: 'Live View',
                    value: 'live',
                    align: 'center'
                  },
                  {
                    sortable: false,
                    text: 'Deposit Events',
                    value: 'deposits',
                    align: 'center'
                  },
                  {
                    sortable: false,
                    text: 'Cash in Transit',
                    value: 'cit',
                    align: 'center'
                  },
                  {
                    align: 'center',
                    sortable: false,
                    value: 'cashin',
                    text: 'Daily Volume'
                  },
                  {
                    align: 'center',
                    sortable: false,
                    value: 'monthly',
                    text: 'Monthly Volume'
                  }
          ]
        } else if (this.$store.getters.user.status === 'admin' || this.$store.getters.user.institution) {
          this.$log.debug('********   user is admin')
          return [
            {
              sortable: true,
              text: 'Sites ID',
              value: 'idnum',
              width: 200
            },
            {
              sortable: true,
              text: 'Group',
              value: 'group',
              width: 200
            },
            {
              sortable: true,
              text: 'Status',
              value: 'status'
            },
            {
              sortable: false,
              text: 'Live View',
              value: 'live',
              align: 'center'
            },
            {
              sortable: false,
              text: 'Deposit Events',
              value: 'deposits',
              align: 'center'
            },
            {
              sortable: false,
              text: 'Cash in Transit',
              value: 'cit',
              align: 'center'
            },
            {
              align: 'center',
              sortable: false,
              value: 'cashin',
              text: 'Daily Volume'
            },
            {
              align: 'center',
              sortable: false,
              value: 'monthly',
              text: 'Monthly Volume'
            }
          ]
        }
      },
      getlocs () {
        this.locations = []
        let today = moment().format('YYYY-MM-DD')

        let eventlist = this.$store.getters.notereaderevents

        for (let [key, value] of Object.entries(this.$store.getters.loadedSiteProfiles)) {
          this.$log.debug('key value is ', key)
          let name = 'Unknown'
          let group = 'Unknown'
          let allowedusers = []
          let loc = this.$store.getters.loadedSites.find(function (site) {
            if (site.idnum === key) {
              return true
            }
          })
          this.$log.debug('LOC IS ', loc)
          if (loc) {
            group = loc.group
            name = loc.sitename
            allowedusers = loc.allowedusers
          }
          if (value.siteunitsprofile) {
            let rejcount = 0
            let safeid = Object.values(value.siteunitsprofile)[0].crypto_idnum
            this.$log.debug('looking for events for safe ', safeid)
            let events = eventlist.filter(event => event.crypto_idnum === safeid)
            if (events.length > 0) {
              let todaysevents = events.filter(event => event.day === today)
              if (todaysevents.length > 0) {
                this.$log.debug('today is ', today, ' Todays events ', todaysevents)
                rejcount = todaysevents[0].rejcount
                // this.$log.debug('count is ', todaysevents[0].rejcount)
              }
              //
            }
            this.$log.debug('rej count is ', rejcount)

            let rec = this.$store.getters.getheartbeatvalues.find(element => element.crypto_idnum === safeid)
            let status = 'N/A'
            if (rec) {
              let now = Date.now()
              let delta = (now - rec.heartbeat)
              // this.lastheartbeat = moment(rec.heartbeat)
              // this.$log.debug('last heartbeat ', this.lastheartbeat)
              if (delta <= 3600000) {
                status = 'Online'
              }
              if (delta >= 3600000) { // 60  minutes
                status = 'Offline'
              }
            }
            let shop = {
              idnum: key,
              group: group,
              safeid: safeid,
              status: status,
              rejcount: rejcount,
              sitename: name
            }
            let stat = this.$store.getters.user.status
            let usrmail = this.$store.getters.user.email
            if (stat === 'admin' || stat === 'corporate' || this.$store.getters.user.institution) {
              this.locations.push(shop)
            } else if (stat === 'storemanager' || stat === 'groupmanager' || stat === 'deposituser' || stat === 'vieweronly' || stat === 'deposituser') {
              if (allowedusers) {
                if (allowedusers.includes(usrmail)) {
                  this.locations.push(shop)
                }
              }
            }
          }
          // this.$log.debug(key,value.siteunitsprofile)
        }
        this.$log.debug('our location map ', this.locations)
        return this.locations
      }
    },
    watch: {
      loading (val) {
        if (!val) return
        setTimeout(() => (this.loading = false), 1000)
      }
    },
    created () {
      this.loading = true
      this.$store.dispatch('loadheartbeats')

      this.$store.dispatch('loadunits')
      this.$store.dispatch('loadsiteProfiles')
      this.$store.dispatch('loadUserGroups')
      this.$store.dispatch('loadSiteConfigs')
      this.$store.dispatch('loadsplitdata')
      // let j = Object.keys(loadedprofiles)
      // let units = loadedprofiles[j[0]].siteunitsprofile
      this.profiles = this.$store.getters.loadedSiteProfiles
    },
    methods: {
      sitestatus (ssid) {
        let rec = this.$store.getters.getheartbeatvalues.filter(element => element.crypto_idnum === ssid)
        let color
        if (rec) {
          if (rec) {
            let now = moment(Date.now())
            this.lastheartbeat = moment(rec.timestamp)
            if (now.diff(this.lastheartbeat) <= 3600000) {
              color = 'Online'
            }
            if (now.diff(this.lastheartbeat) >= 3600000) {
              color = 'Offline'
            }
            return color
          }
          return 'N/A'
        }
        return 'N/A'
      },
      getsitelabel (ssid) {
        // return ssid
        let label = 'unknown'
        // get list of sites in the system
        this.$store.getters.loadedSites.filter(function (site) {
          if (site.idnum === ssid) {
            label = site.sitename
          }
        })
        return label
        // loop thru, find name
        // return sitename
      },
      complete (index) {
        this.list[index] = !this.list[index]
      }
    }
  }
</script>
